import { getEEMSURL } from '@src/env.config';
import CryptoJS from 'crypto-js';
import { encdata } from '@src/constants';

export const encryptProfileParams = (
  version: string,
  asgnId: string,
  srchDestSysCd: string
): string => {
  const payload = JSON.stringify({ version, asgnId, srchDestSysCd });
  return encodeURIComponent(CryptoJS.AES.encrypt(payload, encdata).toString());
};

export const decryptProfileParams = (
  encryptedData: string
): { version: string; asgnId: string; srchDestSysCd: string } => {
  const decrypted = CryptoJS.AES.decrypt(
    decodeURIComponent(encryptedData),
    encdata
  ).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decrypted);
};

export const CACHE_KEY = 'PRIME-EEMS-KEY';
// Function to get cached user details from localStorage
export const getCachedUserDetails = () => {
  if (typeof window === 'undefined') {
    return {
      platform: '',
      username: '',
      userType: '',
      policyNbrs: '',
    };
  }
  const cachedUserDetails: any = localStorage.getItem(CACHE_KEY);

  const userDetails = cachedUserDetails ? JSON.parse(cachedUserDetails) : null;
  return {
    platform: userDetails?.portalType.toString() || '',
    username: userDetails?.username || '',
    userType: userDetails?.userType || '',
    policyNbrs: userDetails?.policyNbrs || '',
    isBroker: userDetails?.broker || false,
  };
};

export const getDetailLink = ({ data, isChild = false }) => {
  const { platform } = getCachedUserDetails();
  let detailURl = new URL(`${getEEMSURL()}rpt/detailView.do`);
  detailURl.searchParams.append('transSetId', data?.transSetId);
  detailURl.searchParams.append('transId', data?.transId);
  detailURl.searchParams.append('platform', platform);
  detailURl.searchParams.append('empId', data?.subscrId);
  if (!isChild) {
    detailURl.searchParams.append('transFileId', data?.transFileId);
  }
  return detailURl;
};

// export const cellValueHighLight = ({ value, fileData, typeValue }) => {
//   const isMulti = fileData?.multilevelSubmitter;
//   const highlight = isMulti && typeValue?.length > 0;

//   return <Box color={highlight ? '#74F3CD' : ''}>{value}</Box>;
// };

export function formatDate(inputDate) {
  if (!inputDate) {
    return '';
  }
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

  return `${year}${month}${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

export const maskString = (str, maskingLength: 'all' | number = 'all') => {
  if (maskingLength === 'all' || !Number.isInteger(maskingLength)) {
    return '*'.repeat(str.length);
  }
  if (str.length <= maskingLength) return str;

  return '*'.repeat(str.length - maskingLength) + str.slice(-maskingLength);
};
export const getProfileListData = (data: any[], id: number) => {
  const listData = data?.find((item) => item?.code === id);
  return listData ? listData.description : 'Code not available';
};

export const getTheType = (dat, i) => {
  const type = dat?.find((type) => type.value === i.trim());

  return type ? type.label : 'UNKNOWN';
};

export const getThelistData = (dat, id): any => {
  const type = dat?.find((type) => type?.value === id);

  return type ? type?.label.trim() : 'UNKNOWN';
};

export const maskUsingUserAccess = (value, dataField, userRole) => {
  const trimmedValue = value?.trim() ?? '';
  if (
    dataField?.includes('Social Security Number') &&
    (userRole == 2 || userRole === 3)
  ) {
    return maskString(trimmedValue, 4);
  }
  if (
    dataField?.toLowerCase()?.includes('salary') &&
    (userRole === 1 || userRole === 3)
  ) {
    return maskString(trimmedValue);
  }
  return trimmedValue;
};

export { cellValueHighLight } from './tableUtils';

//validations

export const validateName = (name) => {
  if (!name || name.trim() === '') {
    return 'Customer Submission Name is a required field. Please enter Customer Submission Name.';
  }
  // Add more validation rules if needed
};
export const validateStreetorCity = (label, street) => {
  if (!street || street === '') {
    return `${label} is a required field. Please enter ${label}.`;
  }
};

export const validateEmail = (label, email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email) {
    return 'Email is required.';
  } else if (!emailRegex.test(email)) {
    return 'Invalid email format.';
  }
};
export const validateEEsuserId = (id) => {
  const regex = /^[a-z0-9]*$/; // Regex to allow only lowercase alphabets and digits
  if (regex.test(id)) {
    return;
  } else {
    return `Please enter only lowercase letters and digits on Employer eServices ID/External UserID "${id}"`;
  }
};
export const validateInputs = (label, submissionId) => {
  const regex = /^[A-Za-z0-9.,\-`()&'" \/\\]+$/;
  if (!submissionId || submissionId.trim() === '') {
    return `${label} is a required field. Please enter ${label}.`;
  }
  if (!regex.test(submissionId)) {
    return `${label} must contain only letters, numbers, and the following special characters: ., - \` () & ' "`;
  }
};
export const populationValidation = (popNumber) => {
  if (!parseInt(popNumber) || parseInt(popNumber) < 0) {
    return 'Invalid Profile Population. Profile Population must be greater then 0';
  }
};

export const validateProfile = (label, id) => {
  if (!id || id.trim() === '') {
    return `Invalid ${label}.`;
  }
};
export const validateState = (state) => {
  if (!state || state.trim() === '') {
    return 'Please select a State';
  }
};

export const validatePolicyNumber = (label, policyNumber) => {
  const regex = /^[0-9]{7}$/;
  if (!policyNumber || policyNumber.trim() === '') {
    return `${label} is a required field. Please enter ${label}.`;
  }
  if (!regex.test(policyNumber)) {
    return `Invalid ${label}. ${label} must be a 7 digit number`;
  }
};
export const validateVersionEndDate = (label, startDate, endDate) => {
  const [startMonth, startDay, startYear] = startDate.split('/');
  const start = new Date(`20${startYear}-${startMonth}-${startDay}`);

  const [endMonth, endDay, endYear] = endDate.split('/');
  const end = new Date(`20${endYear}-${endMonth}-${endDay}`);

  // Allow end date to be the same day or later than the start date
  if (end < start) {
    return 'Version end date must be the same day or later than the version start date.';
  }
};
export const validateDate = (label, date) => {
  const datePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  if (!datePattern.test(date)) {
    return `Invalid ${label}. Enter mm/dd/yyyy`;
  }
  if (!date || date.trim() === '') {
    return `${label} is a required field. Please enter ${label}.`;
  }
  if (date) {
    const [month, day, year] = date.split('/').map(Number);
    const selectedDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to midnight to compare only the date part

    if (selectedDate < today) {
      return `${label}  must be today or later`;
    }
  }
};
export const dateFormat = (datestring) => {
  const date = new Date(datestring);
  if (isNaN(date.getTime())) {
    return '';
  }
  return format(date, 'MM/dd/yyyy');
};

// export const utcFormat =(dateField)=>{

//   if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2} [AP]M UTC$/.test(dateField)) {
//     return dateField
//   }
//     if(dateField) {
//       const date = parse(dateField, 'MM/dd/yyyy', new Date());
//       const versionEffectiveDate = format(date, "yyyy-MM-dd hh:mm a 'UTC'")
//       return versionEffectiveDate
//     }
//     if(!dateField){

//     }
// }

export const formtDate = (dateString) => {
  // Create a new Date object from the UTC date string
  if (typeof dateString !== 'string') {
    return '';
  }
  // Create a new Date object from the input date string
  const datePart = dateString.split(' ')[0];
  const [year, month, day] = datePart.split('-');

  // Format the date as MM/DD/YYYY
  return `${month}/${day}/${year}`;
};

export const convertToCST = (dateString) => {
  // Check if dateString is empty or not a string
  if (typeof dateString !== 'string' || dateString.trim() === '') {
    return '';
  }
  // We append 'CST' just for clarity — it doesn't affect the actual date value
  if (dateString.endsWith('UTC')) {
    return dateString.replace(/\s*UTC$/, ' CST');
  }

  // Split the input date string into month, day, and year
  const [month, day, year] = dateString.split('/');

  // Check if the date parts are valid numbers
  if (!month || !day || !year || isNaN(month) || isNaN(day) || isNaN(year)) {
    return '';
  }

  // Create a new Date object using the extracted values
  const date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0));

  // Format the date as YYYY-MM-DD 00:00 AM UTC
  const formattedDate = `${date.getUTCFullYear()}-${String(
    date.getUTCMonth() + 1
  ).padStart(2, '0')}-${String(date.getUTCDate()).padStart(
    2,
    '0'
  )} 00:00 AM CST`;

  return formattedDate;
};
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export const convertStrintoArray = (data) => {
  if (typeof data === 'string') {
    const cleanedString = data.replace(/[^a-zA-Z0-9, ]/g, '');
    const replacedString = cleanedString.replace(/,/g, ' ');

    return replacedString.split(' ').filter((item) => item !== '');
  } else if (Array.isArray(data)) {
    return data;
  } else {
    return [];
  }
};

export const validateInput = (label, dateString) => {
  if (!dateString || dateString.trim() === '') {
    return `${label} is a required field. Please enter ${label}.`;
  }
  if (dateString.endsWith('UTC')) {
    return;
  }
  // Regular expression to match the MM/dd/yyyy format
  // Regular expression to match the MM/dd/yyyy format
  const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;

  // Check if the date string matches the regex pattern
  if (!regex.test(dateString)) {
    return `${label}must be in MM/dd/yyyy format`;
  }

  // Split the date string into month, day, and year
  const [month, day, year] = dateString.split('/').map(Number);

  // Check if the date parts form a valid date
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return `Invalid ${label}`;
  }
};
export const validateNextExpedAndEarlyStart = (label, dateString) => {
  if (!dateString || dateString.trim() === '') {
    return;
  }
  if (dateString.endsWith('UTC')) {
    return;
  }
  // Regular expression to match the MM/dd/yyyy format
  // Regular expression to match the MM/dd/yyyy format
  const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;

  // Check if the date string matches the regex pattern
  if (!regex.test(dateString)) {
    return `${label}must be in MM/dd/yyyy format`;
  }

  // Split the date string into month, day, and year
  const [month, day, year] = dateString.split('/').map(Number);

  // Check if the date parts form a valid date
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return `Invalid ${label}`;
  }
};

export const modifyArray = (array) => {
  return array?.filter((item) => item?.thresholdType !== '32'); // Remove the object with thresholdType "32"
};
export const getIdsByName = (responseArray, list) => {
  const names = responseArray.map((item) => item.name);
  return list
    .filter((item) => names.includes(item.name))
    .map((item) => item.id);
};

export const getVersionListBySubmitterGroupName = (
  history,
  submitterGroupName
) => {
  // Filter the history array to find the matching submitterGroupName
  const filteredHistory = history?.filter(
    (item) => item.submitterGroupName === submitterGroupName
  );

  // If no matching submitterGroupName is found, return an empty array
  if (filteredHistory?.length === 0) {
    return [];
  }

  // Extract the versions from the filtered history
  const versions = filteredHistory[0]?.versions;

  return versions;
};

// Example usage:

export const footerDateformat = (utcDateString) => {
  if (typeof utcDateString !== 'string') {
    return '';
  }

  // Parse the date string and convert to 24-hour format
  const [datePart, timePart, period] = utcDateString.split(' ');
  let [hours, minutes] = timePart.split(':').map(Number);

  if (period === 'PM' && hours !== 12) {
    hours += 12;
  } else if (period === 'AM' && hours === 12) {
    hours = 0;
  }

  const formattedDateString = `${datePart}T${String(hours).padStart(
    2,
    '0'
  )}:${String(minutes).padStart(2, '0')}:00Z`;

  // Create a new Date object from the formatted date string
  const date = new Date(formattedDateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return '';
  }

  // Extract the month, day, and year
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();

  // Format the date as MM/DD/YYYY
  return `${month}/${day}/${year}`;
};
